import React, { CSSProperties } from "react";
import { SpacingBox } from "../../../components/layout/spacing-box";

type propsType = {
    message: string;
};

export const FieldError: React.FC<propsType> = (props: propsType) => {
    const errorStyle: CSSProperties = {
        color: "var(--danger)",
        fontSize: 12,
    };
    return (
        <SpacingBox mt={4}>
            <span style={errorStyle}>{props.message}</span>
        </SpacingBox>
    );
};
